import { Link } from 'react-router-dom'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
  /**
   * Optional classes applied directly to the <img>. Appended after the
   * size map so a caller can override height (e.g. the sidebar pins the
   * logo to h-9) WITHOUT mutating the shared size map used by the auth
   * pages (which must stay at the `lg` = h-10 height).
   */
  imgClassName?: string
  showSlogan?: boolean
  linkTo?: string
}

export function Logo({ size = 'md', className = '', imgClassName = '', showSlogan = false, linkTo = '/hotel-dashboard' }: LogoProps) {
  // Logo dimensions: 623x147px (4.24:1 aspect ratio)
  // Using SVG for crisp rendering at all sizes
  const sizeClasses = {
    sm: 'h-8 w-auto',    // 32px height, auto width
    md: 'h-10 w-auto',   // 40px height, auto width
    lg: 'h-10 w-auto',   // 40px height, fits sidebar width
    xl: 'h-28 w-auto'    // 112px height, auto width for aspect ratio
  }

  const sloganSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  }

  // Check if className includes items-center to center the slogan text
  const isCentered = className.includes('items-center')

  const logoContent = (
    <>
      <img
        src="/hoteliate.svg"
        alt="Hoteliate"
        className={`${sizeClasses[size]} object-contain cursor-pointer hover:opacity-80 transition-opacity ${imgClassName}`}
      />
      {showSlogan && (
        <p className={`${sloganSizeClasses[size]} text-neutral-600 mt-1 font-display italic ${isCentered ? 'text-center' : ''}`}>
          {/* #602 — brand slogan is hardcoded English in every locale (never translated). */}
          Your Gateway to Alternative Hotel Growth
        </p>
      )}
    </>
  )

  return (
    <Link to={linkTo} className={`flex flex-col items-start ${className}`}>
      {logoContent}
    </Link>
  )
}
